<footer>
  <p class="definition">
    Urban population is the amount of people living in urban areas. Countries
    may differ in how the classify population as urban or rural. GDP per capita
    is the gross domestic product of a country divided by its midyear
    population.
  </p>
  <p>
    Developed by{" "}
    <a
      href="https://www.linkedin.com/in/lcollares"
      target="_blank"
      rel="noopener noreferrer"
    >
      Leandro Collares
    </a>{" "}
    &middot; Source:{" "}
    <a
      href="https://data.worldbank.org/"
      target="_blank"
      rel="noopener noreferrer"
    >
      The World Bank
    </a>
  </p>
</footer>

<style>
  footer {
    margin-top: 5px;
    margin-bottom: 20px;
  }

  p {
    text-align: center;
  }

  .definition {
    text-align: left;
    line-height: 18px;
    max-width: 600px;
  }

  a {
    outline: none;
    text-decoration: none;
  }

  a:visited {
    color: #4427ca;
  }

  a:active {
    color: #dc267f;
  }

  a:hover {
    color: #dc267f;
    border-bottom: 1px dotted;
  }
</style>
